import * as SeparatorPrimitive from "@radix-ui/react-separator";
import React from "react";

import { cn } from "../cn";

export function Separator({ className, orientation = "horizontal", decorative = true, ...props }: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "tw-shrink-0 tw-bg-border data-[orientation=horizontal]:tw-h-px data-[orientation=vertical]:tw-h-full data-[orientation=horizontal]:tw-w-full data-[orientation=vertical]:tw-w-px",
        className,
      )}
      {...props}
    />
  );
}
